<template>
  <div class="custom-progress-wrapper">
    <van-progress
        :percentage="percentage"
        :show-pivot="false"
        :stroke-width="8"
        color="var(--progress-color)"
    />
    <div class="percentage">
      {{percentage}}%
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomProgress',
  props: {
    percentage: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style scoped lang="scss">
.custom-progress-wrapper {
  height: 12px;
  background-color: rgba(0, 0, 0, 0.06);
  border-radius: 6px;
  display: flex;
  position: relative;

  & > div {
    flex: 1;
    margin: auto;
  }
  .percentage {
    position: absolute;
    top: 0;
    right: 0;
    line-height: 12px;
    font-size: 12px;
  }
}
</style>